import { RatingModule } from 'primeng/rating';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { EnumToValuePipe } from './pipes/enum-to-value.pipe';
import { KeyToLabelPipe } from './pipes/key-to-label.pipe';
import { CustomCalendarComponent } from './components/custom-calendar/custom-calendar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { StepsModule } from 'primeng/steps';
import { ImageModule } from 'primeng/image';
import { FieldsetModule } from 'primeng/fieldset';
import { NgxEditorModule } from 'ngx-editor';
import { ChartModule } from 'primeng/chart';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RippleModule } from 'primeng/ripple';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PasswordModule } from 'primeng/password';
import { ChipModule } from 'primeng/chip';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { ClipboardModule } from 'ngx-clipboard';
import { PaginatorModule } from 'primeng/paginator';
import { DividerModule } from 'primeng/divider';
import { InputOtpModule } from 'primeng/inputotp';
import { CodeVerificationDialogComponent } from './components/code-verification-dialog/code-verification-dialog.component';
import { ReciptDialogComponent } from './components/recipt-dialog/recipt-dialog.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { RejectionDialogComponent } from './components/rejection-dialog/rejection-dialog.component';

@NgModule({
  declarations: [
    EnumToValuePipe,
    KeyToLabelPipe,
    CustomCalendarComponent,
    BreadcrumbComponent,
    CodeVerificationDialogComponent,
    ReciptDialogComponent,
    MessageDialogComponent,
    RejectionDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    DialogModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    DropdownModule,
    SelectButtonModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    ConfirmDialogModule,
    MultiSelectModule,
    OverlayPanelModule,
    CalendarModule,
    ToggleButtonModule,
    PasswordModule,
    ChipModule,
    FieldsetModule,
    CardModule,
    TooltipModule,
    TagModule,
    ImageModule,
    MenuModule,
    ClipboardModule,
    PaginatorModule,
    InputOtpModule,
  ],
  exports: [
    EnumToValuePipe,
    KeyToLabelPipe,
    CustomCalendarComponent,
    BreadcrumbComponent,
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    FormsModule,
    AccordionModule,
    DynamicDialogModule,
    ImageModule,
    StepsModule,
    RatingModule,
    FieldsetModule,
    NgxEditorModule,
    ChartModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    DropdownModule,
    SelectButtonModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    ConfirmDialogModule,
    MultiSelectModule,
    OverlayPanelModule,
    CalendarModule,
    ToastModule,
    ToggleButtonModule,
    PasswordModule,
    ChipModule,
    CardModule,
    TooltipModule,
    TagModule,
    MenuModule,
    ClipboardModule,
    PaginatorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PasswordModule,
    DividerModule,
    InputOtpModule,
    CodeVerificationDialogComponent,
    ReciptDialogComponent,
    MessageDialogComponent,
    RejectionDialogComponent,
  ],
  providers: [MessageService],
})
export class SharedModule {}
